export type CrawlerUaPolicyType = 'render-allowed' | 'stale-only';

const RENDER_ALLOWED_CRAWLER_UA_PATTERNS = [
  'googlebot',
  'googleother',
  'google-inspectiontool',
  'google-extended',
  'bingbot',
  'bingpreview',
  'gptbot',
  'claudebot',
  'ccbot',
  'anthropic-ai',
  'perplexitybot',
  'perplexity-bot',
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'slackbot',
  'telegrambot',
  'whatsapp',
  'discordbot',
];

const STALE_ONLY_CRAWLER_UA_PATTERNS = [
  'duckduckbot',
  'baiduspider',
  'sogou',
  'yandexbot',
  'applebot',
  'petalbot',
  'bytespider',
  'amazonbot',
  'ahrefsbot',
  'semrushbot',
  'dataforseobot',
  'sleepbot',
  'mj12bot',
  'dotbot',
  'seznambot',
];

// No generic 'bot'/'crawler' substrings: real device UAs contain them (e.g. the CUBOT phone brand).

export function getCrawlerUaPolicy(
  userAgent: string | null | undefined,
): CrawlerUaPolicyType | null {
  if (!userAgent) {
    return null;
  }
  const lower = userAgent.toLowerCase();
  if (RENDER_ALLOWED_CRAWLER_UA_PATTERNS.some((pattern) => lower.includes(pattern))) {
    return 'render-allowed';
  }
  if (STALE_ONLY_CRAWLER_UA_PATTERNS.some((pattern) => lower.includes(pattern))) {
    return 'stale-only';
  }
  return null;
}
